<template>
  <div>
    <v-layout>
      <v-dialog v-model="show" max-width="1200px" lazy>
        <!-- <v-toolbar color="blue darken-2" dark>
          <v-icon large left>mdi-bullseye-arrow</v-icon>
          <v-toolbar-title>Evaluation</v-toolbar-title>
        </v-toolbar> -->
        <v-card>
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="closeThis">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Procedures</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="buildPdf">Print</v-btn>
              <v-btn dark flat @click="save">Save</v-btn>

            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 order-xs3 class="text-xs-center text-sm-center">
                  <v-layout wrap>
                    <v-flex xs6 md4>
                    <v-select
                      :items="accepts"
                      v-model="editItem.accept"
                      menu-props="auto"
                      label="Accept"
                      hide-details
                    ></v-select>
                  </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.purpose"
                        label="Purpose- Why does this committee exist within Reno Rodeo?"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.responsibility"
                        label="Responsibilities- What does this committee do that  allows it to fulfill it's purpose within Reno Rodeo?"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.manPower"
                        label="Committee Man Power Needs- How many volunteers?"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.skills"
                        label="Committee Man Power Needs- Are there any special skill sets or traits that Man Power should consider when assigning volunteers?"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.equipment"
                        label="Special Equipment Needs"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.equipmentNotes"
                        label="Notes about Equipment Needs- include quantities here. Also include notes about from whom/where you procure the resources (i.e. 6 radios picked up at security trailer on work day, 1 portable office delivered by Quick Space after work day)"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.otherNeeds"
                        label="Other Needs"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.notesOther"
                        label="Notes about Other Needs"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.otherCommittees"
                        label="The Committee communicates/coordinates with the following:"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.notesComm"
                        label="Notes about other committees you coordinate/communicate with"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <template>
                        <div>
                          <v-toolbar flat color="white">
                            <v-toolbar-title>Vendors</v-toolbar-title>
                            <v-divider
                              class="mx-2"
                              inset
                              vertical
                            ></v-divider>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="500px">
                              <template v-slot:activator="{ on }">
                                <v-btn color="primary" dark class="mb-2" v-on="on">New Vendor</v-btn>
                              </template>
                              <v-card>
                                <v-card-title>
                                  <span class="headline">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                  <v-container grid-list-md>
                                    <v-layout wrap>
                                      <v-flex xs12>
                                        <v-text-field v-model="editedItem.company" label="Company"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12>
                                        <v-text-field v-model="editedItem.purpose" label="Purpose"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm6>
                                        <v-text-field v-model="editedItem.firstName" label="Contact First Name"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm6>
                                        <v-text-field v-model="editedItem.lastName" label="Contact Last Name"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm6>
                                        <v-text-field v-model="editedItem.phone" label="Phone"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12>
                                        <v-text-field v-model="editedItem.email" label="email"></v-text-field>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-card-text>

                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
                                  <v-btn color="blue darken-1" flat @click="saveVendor">Save</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-toolbar>
                          <v-data-table
                            :headers="headers"
                            :items="vendors"
                            class="elevation-1"
                          >
                            <template v-slot:items="props">
                              <td>{{ props.item.company }}</td>
                              <td>{{ props.item.purpose }}</td>
                              <td>{{ props.item.fullName }}</td>
                              <td>{{ props.item.phone }}</td>
                              <td>{{ props.item.email }}</td>
                              <td class="justify-center layout px-0">
                                <v-icon
                                  small
                                  class="mr-2"
                                  @click="editThisItem(props.item)"
                                >
                                  edit
                                </v-icon>
                                <v-icon
                                  small
                                  @click="deleteItem(props.item)"
                                >
                                  delete
                                </v-icon>
                              </td>
                            </template>
                            <template v-slot:no-data>
                              No Vendors assigned
                            </template>
                          </v-data-table>
                        </div>
                      </template>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.august"
                        label="August"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.sepember"
                        label="Sepember"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.october"
                        label="October"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.november"
                        label="November"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.december"
                        label="December"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.january"
                        label="January"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.feburary"
                        label="February"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.march"
                        label="March"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.april"
                        label="April"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.may"
                        label="May"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.june"
                        label="June"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.july"
                        label="July"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.notesDate"
                        label="Notes about timeline by month"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.dailyOps"
                        label="Notes about operating daily schedule during rodeo"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.afternoon"
                        label="Afternoon- 12:00 pm to 4:59 pm"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.morning"
                        label="Morning- 12:00 am to 11:59 am"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.night"
                        label="Night- 5:00 pm to 11:59 pm"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.comments"
                        label="Other Comments"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="blue darken-1"
              flat
              @click.stop="show=false"
            >Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              dark
              transition="fade-transition"
              @click.native="save"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-layout>
  </div>
</template>

<script>
import Api from '@/services/Api'

export default {
  props: ['visible', 'item', 'committee'],

  data () {
    return {
      saving: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editItem: {},
      dialog: false,
      headers: [
        { text: 'Company', value: 'company' },
        { text: 'Purpose', value: 'purpose' },
        { text: 'Contact', value: 'fullName' },
        { text: 'Phone', value: 'phone' },
        { text: 'Email', value: 'email' },
        { text: 'Actions', value: 'name', sortable: false }
      ],
      accepts: [
        { text: 'No', value: false },
        { text: 'Yes', value: true }
      ],
      vendors: [],
      editedIndex: -1,
      editedItem: {
        id: 0,
        company: '',
        purpose: '',
        firstName: '',
        lastName: '',
        fullName: '',
        phone: '',
        email: ''
      },
      defaultItem: {
        id: 0,
        company: '',
        purpose: '',
        firstName: '',
        lastName: '',
        fullName: '',
        phone: '',
        email: ''
      }
    }
  },

  created () {
    // console.log('comm', this.committee)
    this.getPolicy()
  },

  computed: {
    user () {
      return this.$store.state.user
    },

    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', this.editItem)
        }
      }
    },

    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    }
  },

  watch: {
    visible (val) {
      if (val) {
        this.getPolicy()
      }
    },

    editedItem: {
      handler: function (val, oldVal) {
        this.saving = true
      },
      deep: true
    },

    dialog (val) {
      val || this.close()
    }
  },

  methods: {
    getPolicy () {
      this.editItem = this.item[0]
      this.editItem.committeeName = this.committee.committeeName
      this.vendors = this.item[0].PolicyContacts
    },

    loadItem () {
      // console.log(this.item)
    },

    async save () {
      try {
        let response = null

        if (this.editItem.id > 0) {
          response = await Api().put('policy/' + this.editItem.id, this.editItem)
        } else {
          response = await Api().post('policy', this.editItem)

          this.editItem = response.data.policy
        }

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    closeThis () {
      this.show = false
    },

    async editThisItem (item) {
      item.fullName = item.firstName + ' ' + item.lastName
      item.PolicyId = this.editItem.id

      this.editedIndex = this.vendors.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    async deleteItem (item) {
      const index = this.vendors.indexOf(item)
      let r = confirm('Are you sure you want to delete this item?')

      if (r === true) {
        try {
          const response = await Api().delete('policy_vendor/' + item.id)
          this.vendors.splice(index, 1)

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async buildPdf () {
      try {
        await Api().post('get_printprocedure', this.editItem).then((response) => {
          window.open(process.env.API_URL + '/attachments/' + this.editItem.CommitteeId + '.pdf', '_blank')

          // console.log(route)
          console.log(response)
        })
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async saveVendor () {
      try {
        this.editedItem.fullName = this.editedItem.firstName + ' ' + this.editedItem.lastName
        this.editedItem.PolicyId = this.editItem.id

        let response = null

        if (this.editedItem.id > 0) {
          response = await Api().put('policy_vendor/' + this.editedItem.id, this.editedItem)
        } else {
          response = await Api().post('policy_vendor', this.editedItem)

          // this.editedItem = response.data.policy
        }

        if (this.editedIndex > -1) {
          Object.assign(this.vendors[this.editedIndex], this.editedItem)
        } else {
          this.vendors.push(this.editedItem)
        }
        this.close()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

input[type="file"]{
  position: absolute;
  top: -500px;
}

span.remove-file{
  color: red;
  cursor: pointer;
  float: right;
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/PolicyForm.vue